import React from 'react';
import EditEmailTemplateView from '../view/EditEmailTemplateView';

const EditEmailTemplateEngine = ({
  templateId, // maybe we'll want to use this in the future
  data,
  setIsDirty = v => v,
  additionalSettings
}) => {
  const viewProps = {
    subject: data.subjectInEdit,
    body: data.bodyInEdit,
    setIsDirty,
    additionalSettings
  };
  return <EditEmailTemplateView {...viewProps} />;
};

export default EditEmailTemplateEngine;
